import { asApiFailure } from "@utils/apiFailure";

// Substring of the API's cancelled-client 409. The sibling 409 (nothing
// awaiting signup) carries different text, and the status code alone cannot
// tell them apart - hence ApiError.detail, as in approve.ts.
const CANCELLED = "is cancelled";

// Maps a failed POST organizations/{id}/invitation/resend into admin copy.
export const resendInvitationErrorMessage = (error: unknown): string => {
    const failure = asApiFailure(error);

    switch (failure?.status) {
        case 403:
            return "You do not have permission to resend invitations.";

        case 404:
            return "No link was sent: this client no longer exists. It may have been deleted.";

        case 409:
            return failure.detail?.includes(CANCELLED)
                ? "No link was sent: this client is cancelled. Reactivate the client first, then resend the invitation."
                : "No link was sent: the applicant has already signed up.";

        // A 500 means the new link was issued (earlier ones are dead) but its
        // email failed; a dropped network says nothing. Sending again issues
        // another link, so it is always safe.
        default:
            return "The link may not have been sent. Try again: it's safe, and only the newest link works.";
    }
};
